module.exports = __webpack_public_path__ + "img/CB12-Off-On-1.d135531b.gif";